import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const mediaSrc = (path) => (path ? `${BACKEND_URL}${path}` : null);

// Chunked upload: splits the file into pieces (to stay under the ~100MB Cloudflare request-body
// limit on custom domains) and uploads several in parallel so a fast connection isn't bottlenecked
// by sequential round-trips. Each chunk carries its index so parallel/retried chunks reassemble in order.
export const uploadFileChunked = async (file, { onProgress } = {}) => {
  const { data: begin } = await api.post("/uploads/begin", { filename: file.name, size: file.size });
  const { upload_id, chunk_size, concurrency = 4 } = begin;
  const nChunks = Math.max(1, Math.ceil(file.size / chunk_size));
  let uploaded = 0;
  let next = 0;
  const worker = async () => {
    while (true) {
      const idx = next++;
      if (idx >= nChunks) break;
      const start = idx * chunk_size;
      const blob = file.slice(start, Math.min(start + chunk_size, file.size));
      await api.post(`/uploads/${upload_id}/chunk?idx=${idx}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
      uploaded += blob.size;
      onProgress?.(Math.min(99, Math.round((uploaded / file.size) * 100)));
    }
  };
  await Promise.all(Array.from({ length: Math.min(concurrency, nChunks) }, worker));
  await api.post(`/uploads/${upload_id}/finalize`, {});
  onProgress?.(100);
  return upload_id;
};

export const errorMessage = (e, fallback = "Something went wrong") =>
  e?.response?.data?.detail ? (typeof e.response.data.detail === "string" ? e.response.data.detail : JSON.stringify(e.response.data.detail)) : e?.message || fallback;

export const PLATFORMS = [
  { id: "tiktok", label: "TikTok", framing: "9:16" },
  { id: "reels", label: "Instagram Reels", framing: "9:16" },
  { id: "shorts", label: "YouTube Shorts", framing: "9:16" },
  { id: "x", label: "X", framing: "16:9" },
  { id: "linkedin", label: "LinkedIn", framing: "1:1" },
  { id: "facebook", label: "Facebook", framing: "1:1" },
];
export const HOOK_STYLES = ["question", "pattern-interrupt", "story", "punchy"];
export const CAPTION_STYLES = ["bold", "subtitle", "karaoke", "minimal"];
export const PACINGS = ["cinematic", "natural", "fast"];
export const FRAMINGS = ["9:16", "1:1", "16:9"];

export const fmtDuration = (s) => {
  if (s == null) return "–";
  const m = Math.floor(s / 60);
  const sec = Math.round(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
};
export const fmtBytes = (b) => (b > 1e9 ? `${(b / 1e9).toFixed(2)} GB` : b > 1e6 ? `${(b / 1e6).toFixed(1)} MB` : `${Math.round(b / 1e3)} KB`);
